"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapClientStatusToPublic = exports.mapServerToClientStatus = exports.isFailedServerStatus = exports.isInProcessServerStatus = exports.isPendingServerStatus = exports.isApprovedServerStatus = void 0;
const BuyerServerTransactionStatus_1 = require("../../enums/transactions/BuyerServerTransactionStatus");
const isApprovedServerStatus = (serverStatus) => [BuyerServerTransactionStatus_1.BuyerServerTransactionStatus.Approved, BuyerServerTransactionStatus_1.BuyerServerTransactionStatus.Authorized].includes(serverStatus);
exports.isApprovedServerStatus = isApprovedServerStatus;
const isPendingServerStatus = (serverStatus) => [
    BuyerServerTransactionStatus_1.BuyerServerTransactionStatus.PendingMerchant,
    BuyerServerTransactionStatus_1.BuyerServerTransactionStatus.PendingBuyer,
    BuyerServerTransactionStatus_1.BuyerServerTransactionStatus.Initialized,
    BuyerServerTransactionStatus_1.BuyerServerTransactionStatus.Offline,
].includes(serverStatus);
exports.isPendingServerStatus = isPendingServerStatus;
const isInProcessServerStatus = (serverStatus) => [BuyerServerTransactionStatus_1.BuyerServerTransactionStatus.InProcess, BuyerServerTransactionStatus_1.BuyerServerTransactionStatus.Initialization].includes(serverStatus);
exports.isInProcessServerStatus = isInProcessServerStatus;
const isFailedServerStatus = (serverStatus) => [
    BuyerServerTransactionStatus_1.BuyerServerTransactionStatus.Undefined,
    BuyerServerTransactionStatus_1.BuyerServerTransactionStatus.Declined,
    BuyerServerTransactionStatus_1.BuyerServerTransactionStatus.Failed,
    BuyerServerTransactionStatus_1.BuyerServerTransactionStatus.BuyerCanceled,
    BuyerServerTransactionStatus_1.BuyerServerTransactionStatus.Timeout,
].includes(serverStatus);
exports.isFailedServerStatus = isFailedServerStatus;
const mapServerToClientStatus = (serverStatus) => {
    if ((0, exports.isApprovedServerStatus)(serverStatus)) {
        return 'Approved';
    }
    if ((0, exports.isPendingServerStatus)(serverStatus)) {
        return 'Pending';
    }
    if ((0, exports.isInProcessServerStatus)(serverStatus)) {
        return 'InProcess';
    }
    if ((0, exports.isFailedServerStatus)(serverStatus)) {
        return 'Failed';
    }
    return 'Unknown';
};
exports.mapServerToClientStatus = mapServerToClientStatus;
const mapClientStatusToPublic = (clientStatus) => {
    // there is no point in exposing this granular statuses to the Client, they should treat them as Pending
    if (clientStatus === 'InProcess' || clientStatus === 'Unknown') {
        return 'Pending';
    }
    return clientStatus;
};
exports.mapClientStatusToPublic = mapClientStatusToPublic;
//# sourceMappingURL=buyerServerConverters.js.map